import styled from 'styled-components';
import { DOWN_ARROW } from '../../../../Common/Assets/images';

const OpticalVariantStyled = styled.div`
  .variantBox {
    width: 100%;
    background: ${(props) => props?.theme?.color?.white};
    border: 1px solid ${(props) => props?.theme?.color?.borderLight};
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 16px;

    .titleBar {
      width: 100%;
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 16px;
    }

    .dropdownInput {
      .inputField {
        cursor: default;
        background: url(${DOWN_ARROW.src}) no-repeat;
        background-size: 16px 16px;
        background-position: calc(100% - 16px) 70%;
        font-weight: 600;
        font-size: 16px;
        color: ${(props) => props.theme.text.dark};
      }
      .is-invalid {
        background: url(${DOWN_ARROW.src}) no-repeat !important; 
        background-size: 12px 6px !important;
        background-position: calc(100% - 16px) 70% !important;
      }
    }
    .country-dropdown button {
      font-size: 16px;
    }

    .dropdown-menu,
    .options-dropdown option {
      display: none;
    }

    .dropdown-custom-components {
      font-size: 16px;
    }

    .different-power {
      background: ${(props) => props?.theme?.green?.off};
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 28px;
      gap: 8px;
      height: 44px;
      border-radius: 8px;
      flex: none;
      order: 1;
      align-self: stretch;
      flex-grow: 0;
      padding: 10.5px 12px 10.5px 12px;
    }

    .spherical-options-section {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
      width: 100%;
      height: 44px;
      border-radius: 8px;
      flex: none;
      order: 1;
      align-self: stretch;
      flex-grow: 0;
      margin-bottom: 16px;

      .spherical-label {
        width: 70px;
        height: 12px;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 12px;
        color: ${(props) => props?.theme?.text?.dark};
        margin-bottom: 6px;
      }

      .sph-label {
        font-family: Mulish;
        font-size: 14px;
        font-weight: 500;
        line-height: 12px;
        text-align: left;
        color: ${(props) => props?.theme?.text?.light};
      }

      .spherical-label {
        width: 40%;
      }

      .options-dropdown {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      .options-dropdown > * {
        width: 100%;
      }

      .invalid-sph {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 12px;
        color: ${(props) => props.theme.verification.red.main};
        margin-top: 6px;
      }
    }
  }
`;

export default OpticalVariantStyled;
